import React from "react";
import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./pages/Home";
import Rede from "./pages/Rede";
import Normas from "./pages/Normas";
import Siglas from "./pages/Siglas";
import Tv from "./pages/Tv";
import Telefone from "./pages/Telefone";
import Footer from "./components/Footer";

import Internet from "./pages/Internet";
import Apps from "./pages/Apps";
import Rural from "./pages/Internet/Rural";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";

import "./App.css";

//import PowerMeter from "./pages/Siglas/components/PowerMeter";

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/rede" component={Rede} />  
          <Route path="/normas" component={Normas} />
          <Route path="/siglas" component={Siglas} />
          {/* <Route path="/power" component={PowerMeter} /> */}
          <Route path="/tvs" component={Tv} />
          <Route path="/telefones" component={Telefone} />          
          <Route path="/apps" component={Apps} />
          <Route exact path="/internet/rural" component={Rural} />
          <Route exact path="/internet" component={Internet} /> 
          <Route path="*" component={NotFoundPage} />
        </Switch>
        <br /><br /><br /><br /><br /><br />
        <Footer />
      </Router>
    </div>
  );
}

export default App;
